import { basicBaseApi } from "./basicBaseApi";
import { Methods } from '@newview/infrastructure';


export class StructureinstanceApi extends basicBaseApi {

  public get ControllerName(): any {
    return 'structureinstance'
  }

  public getListByFilter(structureinstance) {
    return this.send(structureinstance, "getListByFilter", Methods.GET)
  }
  /**
   * 根据构件id，计算金额
   * @param cids 构件id，通过，拼接
   * @returns 
   */
  public findDataByCid(cids: string){
    return this.send({cids:cids},"findDataByCid",Methods.GET)
  }

  /**
 * 构件选择_获取单位工程列表
 * @param ids 
 * @param typeId 
 * @param keyWord 
 */
  public getShareUnitEnginreeDataToSelCom(ids: string, nodeType: number) {
    return this.send({ ids: ids, NodeType: nodeType }, 'getShareUnitEnginreeDataToSelCom', Methods.GET)
  }

  /**
* 构件选择_获取单位工程下的分部/分项工程
* @param rootId 
* @param keyWord 
*/
  public getShareOptionEnginreeToSelCom(rootId: number) {
    return this.send({ rootId: rootId }, 'getShareOptionEnginreeToSelCom', Methods.GET)
  }


  public getListByRootIdAndPId(RootId,PId){
    return this.send({ rootId: RootId,PId:PId }, 'getListByRootIdAndPId', Methods.GET)
  }
  /**
   * 获取单位工程列表
   * @param RoadId 
   * @param CreateUnit 
   * @returns 
   */
  public getListByUnit(RoadId,CreateUnit){
    return this.send({ RoadId: RoadId,CreateUnit:CreateUnit}, 'getListByUnit', Methods.GET)
  }
   /**
   * 获取单位工程列表,可以通过名称查询
   * @param RoadId 
   * @param CreateUnit 
   * @returns 
   */
    public getListByUnit1(RoadId,CreateUnit,NodeName){
      return this.send({ RoadId: RoadId,CreateUnit:CreateUnit,NodeName:NodeName}, 'getListByUnit1', Methods.GET)
    }

  /**
   * 批量保存修改
   * @param list 
   */
  public insertOrUpdateList(list){
    return this.send(list, 'insertOrUpdateList', Methods.POST)
  }

  public getStructeInstanceData(RootId){
    return this.send({ RootId: RootId}, 'getStructeInstanceData', Methods.GET)
  }

  public RemoveAllofProject(id){
    return this.send({ id: id}, 'RemoveAllofProject', Methods.GET)
  }

  public updateStructType(list){
    return this.send(list, 'updateStructType', Methods.POST)
  }

  public ImportNodeToInstance(structureinstancePo){
    return this.send(structureinstancePo, 'ImportRowDataToInstance', Methods.POST)
  }

  public getListByPId(roadId,Pid){
    return this.send({ roadId: roadId,Pid:Pid}, 'getListByPId', Methods.GET)
  }
  
  
  public getNodeTypeByIId(iId){
    return this.send({ iId: iId}, 'getNodeTypeByIId', Methods.GET)
  }
  public getNodeTypeByIId1(iId,S_Name){
    return this.send({ iId: iId,S_Name:S_Name}, 'getNodeTypeByIId1', Methods.GET)
  }

  public getFXProjectList(NodeType,RootId,roadId =0 ){
    return this.send({ NodeType: NodeType,RootId:RootId,roadId:roadId}, 'getFXProjectList', Methods.GET)
  }
  

  public CopyAttrFromOneToMore(CId,TCIds){
    return this.send({ CId: CId,TCIds:TCIds}, 'CopyAttrFromOneToMore', Methods.GET)
  }

  public SaveStructureInstanceAttr(structureinstancePo){
    return this.send(structureinstancePo, 'SaveStructureInstanceAttr', Methods.POST)
  }

  /**
   * 查询下一级子节点列表
   */
  public getStructureinstanceListByPId(Pid) {
    return this.send({Pid:Pid},"getStructureinstanceListByPId",Methods.GET)
    
  }
  /**
   * 线路id查询构建类别列表
   * @param roadId 
   */
  public getDataStructureByRoadId(roadId){
    return this.send({roadId:roadId},"getDataStructureByRoadId",Methods.GET)
  }


  /**
   * 线路id查询构建类别列表
   * @param roadId
   */
  public getDataStructureByFilter(params){
    return this.send(params,"getDataStructureByFilter",Methods.GET)
  }



}